export const PASTE_PAPER_COPY = `Paste paper`
export const CHECK_MY_PAPER_BUTTON_COPY = `Check my paper`
export const IMPORT_PAPER_COPY = `or import your paper`
export const COMPUTER_BUTTON_COPY = `Computer`
export const COMPUTER_LABEL_COPY = `Upload from computer`
export const GOOGLE_DRIVE_BUTTON_COPY = `Google Drive`
export const TERMS_CONDITIONS_COPY = `See terms and conditions`
export const HEADER_DEFAULT_COPY = `Turn in your best paper`
export const SUBHEADER_DEFAULT_COPY = `We check your paper against billions of sources using technology similar to Turnitin`
export const LEGAL_COPY = `The papers you upload will be added to our plagiarism database and will be used internally to improve plagiarism results.  Chegg will not share your papers publicly or with any third party.`
export const ERROR_FILETYPE_COPY = `Sorry we don't support this file type. Please try again.`
export const ERROR_DEFAULT_COPY = `Hmm, that didn't work.  Please try again.`
export const ERROR_MAX_COPY = `We have a file maximum of 80KB.  Please try again.`
export const PROCESSING_PAPER_COPY = `Processing your paper`
